import React, { useCallback, useEffect, useState } from 'react';
import classNames from 'classnames';
import { SearchBox } from 'tea-component';

type UsePrMediaKeywordSearchParams = {
  data: unknown;
  changeData: ((key: string, value: unknown) => void) | undefined;
  showSearch: boolean;
  isEN: boolean;
  inTabToolbar: boolean;
};

/**
 * 与 Service `extraParams.keyword` 同步的搜索框；有 changeData 时才展示。
 */
export function usePrMediaKeywordSearch(
  params: UsePrMediaKeywordSearchParams,
): { searchNode: React.ReactNode | null; } {
  const { data, changeData, showSearch, isEN, inTabToolbar } = params;

  const [keywordInput, setKeywordInput] = useState('');
  useEffect(() => {
    const kw = (data as { extraParams?: { keyword?: string; }; })?.extraParams?.keyword;
    setKeywordInput(typeof kw === 'string' ? kw : '');
  }, [data]);

  const pushKeyword = useCallback(
    (raw: string) => {
      if (!changeData) return;
      const next = (raw || '').trim();
      const extraParams = { ...(data as { extraParams?: Record<string, unknown>; })?.extraParams, keyword: next, page: 1 };
      changeData('extraParams', extraParams);
    },
    [changeData, data],
  );

  const searchNode =
    showSearch && changeData ? (
      <div
        className={classNames('dbh-pr-media-table__search', {
          'dbh-pr-media-table__search--in-tab-toolbar': inTabToolbar,
        })}
      >
        <SearchBox
          className="dbh-pr-media-table__search-input"
          placeholder={isEN ? 'Search...' : '搜索...'}
          value={keywordInput}
          onChange={(v) => {
            setKeywordInput(v);
          }}
          onSearch={(v) => {
            pushKeyword(v ?? '');
          }}
          onClear={() => {
            setKeywordInput('');
            pushKeyword('');
          }}
        />
      </div>
    ) : null;

  return { searchNode };
}
